import { sessionLoad } from 'Core/Utils/Session';

export default {
  loading: false,
  errorMessage: null,
  loggedIn: sessionLoad('loggedIn')
    ? sessionLoad('loggedIn')
    : false,
  user: null
};



// WEBPACK FOOTER //
// ./client/RLX/State/Auth/AuthInitialState.js